<app-customer-slots [slots]="customer.landing"></app-customer-slots>
